<template>
    <div class="core-password-wrapper">
        <Password
            v-model="value"
            :name="name"
            :placeholder="$t(placeholder)"
            :class="classes"
            :toggleMask="true"
            :feedback="feedback"
            :disabled="disabled"
            @focus="onFocus()"
            @blur="onBlur()"
        />
        <CoreInputNotification
            v-if="isFocused && validator !== null"
            :validator="validator"
        />
    </div>
</template>

<script>
import Password from 'primevue/password'
import CoreInputNotification from './CoreInputNotification.vue'

export default {
    name: 'CorePasswordInput',

    components: { Password, CoreInputNotification },

    props: {
        modelValue: {
            type: String,
            default: '',
        },

        name: {
            type: String,
            default: '',
        },

        feedback: {
            type: Boolean,
            default: false,
        },

        validator: {
            type: Object,
            default: null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        placeholder: {
            type: String,
            default: '§ui.placeholder_password',
        },
    },

    data() {
        return {
            isFocused: false,
        }
    },

    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)

                if (this.validator) {
                    this.validator.$touch()
                }
            },
        },

        classes() {
            return {
                'core-input': true,
                'core-password-input': true,
                'core-valid': this.isValid,
                'core-invalid': this.isInvalid,
            }
        },

        isValid() {
            if (this.validator !== null && !this.validator.$invalid && this.validator.$dirty) {
                return true
            }

            return false
        },

        isInvalid() {
            if (this.validator !== null && this.validator.$invalid && this.validator.$dirty) {
                return true
            }

            return false
        },

        validatorErrors() {
            if (this.validator.$error === undefined) {
                return {}
            }
            return this.validator.$error
        },

        validatorParams() {
            if (this.validator.$params === undefined) {
                return {}
            }
            return this.validator.$params
        },

        iconClass() {
            return `core-string-input__icon pi ${this.icon}`
        },

        styles() {
            const stylesObject = {}

            if (this.width !== null && typeof this.width === 'number') {
                stylesObject.width = `${this.width}px`
            }

            return stylesObject
        },
    },

    methods: {
        onFocus() {
            this.isFocused = true
            this.$emit('focus')
        },

        onBlur() {
            this.isFocused = false
            this.$emit('blur')
        },
    },
}
</script>

<style>
.core-password-wrapper {
    position: relative;
}
.core-password-input > input {
    font-size: var(--text-base);
}

.p-password-toggle-mask-icon.p-password-mask-icon,
.p-password-toggle-mask-icon.p-password-unmask-icon {
    width: 1.6rem;
    height: 1.6rem;
}
</style>
